import { faHeart, faHeartbeat, faHeartBroken, faShareNodes, faShieldHeart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react'
import "./Product_Image.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { IDS } from '../../../utils/IDS';
import { getAllWishlist, postWishlist } from '../../../features/wishlist/wishlistSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Context } from "../../../utils/context";
import Select_login from '../../common/modals/login-signup-modals/Select_login';
import Login_Layout_Modal from '../../common/modals/login-signup-modals/Login_Layout_Modal';
import { encodeId } from '../../../utils/common';
import { myAccount } from '../../../features/my_account/Slice';


const Product_Image = ({ product }) => {

    const { signin } = useContext(Context);
    const [isClicked, setIsClicked] = useState(false);
    console.log(signin, "signinsigninsignin");
    const [currentImage, setCurrentImage] = useState();
    const [modelType, setModelType] = useState("");
    const [selectLogin, setSelectLogin] = useState(false);



    useEffect(() => {
        if (product?.image) {
            setCurrentImage(IDS.IMG_URL + product.image);
        }
    }, [product]);

    const [swiperInstance, setSwiperInstance] = useState(null);


    class Zoomable {
        constructor(element, config) {
            this.element = element;
            this.config = this._mergeConfig(config);

            const { initialZoom, minZoom, maxZoom } = this.config;

            this.zoomed = false;
            this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
            this.zoom = this.initialZoom;

            this.img = element.querySelector(".zoomable__img");


            this.img.draggable = false;
            this.element.style.setProperty("--zoom", this.initialZoom);

            this._addEventListeners();
        }

        static get Default() {
            return Default;
        }

        _addEventListeners() {
            this.element.addEventListener("mouseenter", () =>
                this._handleMouseover()
            );
            this.element.addEventListener("mousemove", (evt) =>
                this._handleMousemove(evt)
            );
            this.element.addEventListener("mouseleave", () => this._handleMouseout());
            this.element.addEventListener("wheel", (evt) => this._handleWheel(evt));
        }

        _handleMouseover() {
            if (this.zoomed) {
                return;
            }

            this.element.classList.add("zoomable--zoomed");
            this.zoomed = true;
        }

        _handleMousemove(evt) {
            if (!this.zoomed) {
                return;
            }

            const elPos = this.element.getBoundingClientRect();
            const percentageX = `${((evt.clientX - elPos.left) * 100) /
                elPos.width}%`;
            const percentageY = `${((evt.clientY - elPos.top) * 100) /
                elPos.height}%`;

            this.element.style.setProperty("--zoom-pos-x", percentageX);
            this.element.style.setProperty("--zoom-pos-y", percentageY);
        }

        _handleMouseout() {
            if (!this.zoomed) {
                return;
            }

            this.element.style.setProperty("--zoom", this.initialZoom);
            this.element.classList.remove("zoomable--zoomed");
            this.zoomed = false;
        }

        _handleWheel(evt) {
            if (!this.zoomed) {
                return;
            }

            evt.preventDefault();

            const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
            const { minZoom, maxZoom } = this.config;

            this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
            this.element.style.setProperty("--zoom", this.zoom);
        }

        _mergeConfig(config) {
            return {
                ...this.constructor.Default,
                ...(typeof config === "object" ? config : {}),
            };
        }
    }

    const Default = {
        initialZoom: 3,
        minZoom: 1.25,
        maxZoom: 4,
        zoomSpeed: 0.01,
    };

    const zoomableRef = useRef(null);

    useEffect(() => {
        const element = zoomableRef.current;
        if (!element) return;

        const zoomable = new Zoomable(element);

        return () => {
            element.removeEventListener("mouseenter", zoomable._handleMouseover);
            element.removeEventListener("mousemove", zoomable._handleMousemove);
            element.removeEventListener("mouseleave", zoomable._handleMouseout);
            element.removeEventListener("wheel", zoomable._handleWheel);
        };
    }, []);

    function calculateDiscountPercentage(mrp, sellingPrice) {


        if (typeof mrp !== 'number' || typeof sellingPrice !== 'number') {
            throw new Error("MRP and selling price must be numbers.");
        }

        if (mrp < 0) {
            throw new Error("MRP must be a positive number.");
        }

        const discountAmount = mrp - sellingPrice;
        const discountPercentage = (discountAmount / mrp) * 100;

        // Optional: Round the result to two decimal places
        return parseFloat(discountPercentage.toFixed(0));
    }

    const dispatch = useDispatch();

    const postWishlistData = async (data) => {
        const res = await dispatch(postWishlist({ product_id: data }));

        if (res.meta?.requestStatus === "fulfilled") {
            await dispatch(getAllWishlist());
            // await dispatch(getAllProducts({}));
            // await dispatch(getGroupByProduct({}));
        } else if (res.meta?.requestStatus === "rejected") {
        }

    };
    const allWishlist = useSelector((state) => state.wishlist.allWishlist);

    const user = useSelector((state) => state.myaccount.addMyaccount);

    useEffect(() => {
        if (signin)
            dispatch(myAccount());
    }, [dispatch]);


    useEffect(() => {
        if (signin)
            dispatch(getAllWishlist());
    }, [dispatch]);


    const productUrl = `${window.location.origin}/product-details/${encodeId(product?.id,)}?user_id=${encodeId(user?.id)}`;

    const productName = product?.name;

    const handleShare = () => {
        const url = productUrl || window.location.href;
        const title = productName || document.title;

        if (navigator.share) {
            // Native share (mobile + some desktop browsers)
            navigator
                .share({
                    title: title,
                    text: `Check out this product: ${title}`,
                    url: url,
                })
                .catch((err) => console.error("Share cancelled", err));
        } else {
            // Fallback: Open social share links (example: WhatsApp)
            const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`Check out this product: ${title} - ${url}`,
            )}`;
            window.open(whatsappUrl, "_blank");
        }
    };

    return (
        <div className='Product_Image'>

            <div className='row'>
                <div className='col-lg-12 col-md-12'>
                    <div className='img_main_container'>


                        <div className="product-detail text-center">
                            <div className="specs" ref={zoomableRef}>
                                <img
                                    src={process.env.PUBLIC_URL + currentImage}
                                    className="zoomable__img"
                                    alt="Selected"
                                />

                            </div>
                        </div>

                        <p className='offerp'>{calculateDiscountPercentage(parseInt(product?.mrp || 0), parseInt(product?.price || 0))}% Off</p>

                        {signin &&
                            <div className='icon_holder' onClick={() => postWishlistData(product?.id)}>
                                <FontAwesomeIcon
                                    icon={faHeart}
                                    className={`heart_icon ${allWishlist?.data?.some((item) => item.product_id === product?.id) ? 'clicked' : ''}`} />
                            </div>
                        }
                        {!signin &&
                            <div className='icon_holder' onClick={() => { setModelType("select_login"); setSelectLogin(true); }}>
                                <FontAwesomeIcon

                                    icon={faHeart}

                                    className={`heart_icon ${product?.Wishlist?.id ? 'clicked' : ''}`} />
                            </div>

                        }

                        <div className='icon_holder2' onClick={() => handleShare()} >
                            <FontAwesomeIcon icon={faShareNodes} />
                        </div>


                    </div>
                </div>

                <div className='col-lg-12 col-md-12'>
                    <div className="main">
                        <div className="sidebar-swiper">
                            <Swiper
                                slidesPerView={"auto"} autoplay={{
                                    delay: 2000,
                                    disableOnInteraction: false,
                                }}
                                modules={[Navigation, Autoplay]}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 3,
                                        spaceBetween: 10,
                                    },
                                    380: {
                                        slidesPerView: 4,
                                        spaceBetween: 10,
                                    },
                                    485: {
                                        slidesPerView: 5,
                                        spaceBetween: 10,
                                    },
                                    575: {
                                        slidesPerView: 5,
                                        spaceBetween: 5,
                                    },

                                    768: {
                                        slidesPerView: 5,
                                        spaceBetween: 10,
                                    },
                                    992: {
                                        slidesPerView: 4,
                                        spaceBetween: 10,
                                    },
                                    1024: {
                                        slidesPerView: 4,
                                        spaceBetween: 10,
                                    },
                                    1200: {
                                        slidesPerView: 5,
                                        spaceBetween: 10,
                                    },
                                    1440: {
                                        slidesPerView: 6,
                                        spaceBetween: 10,
                                    },
                                    2000: {
                                        slidesPerView: 6,
                                        spaceBetween: 10,
                                    },
                                }}
                                navigation
                                pagination={{ clickable: true }}
                                className="mySwiper category_slider product_image_slider"
                                onSwiper={(swiper) => setSwiperInstance(swiper)}
                            >
                                {product?.Product_Images?.map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <div
                                            className="gallery-imgs"
                                            onClick={() => setCurrentImage(IDS.IMG_URL + item.image)}

                                        >
                                            <img
                                                src={IDS.IMG_URL + item.image}
                                                className="inner-img"
                                                alt={`Image ${index + 1}`}
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>

                        </div>
                    </div>
                </div>
            </div>



            <div className=''></div>
            <Login_Layout_Modal
                modalType={modelType}
                show={selectLogin}
                onHide={() => setSelectLogin(false)}
            />

        </div>
    )

}

export default Product_Image
